import React from "react";
import { Img } from "../../design-system/Img";

interface InstructionBoxProps {
  img: string;
  id: string;
  className?: string;
}

const InstructionBox: React.FC<InstructionBoxProps> = ({ id, img, className }) => {
  return (
    <Img
      src={img}
      alt="phone"
      className={`${className}`}
    />
  );
};

export default InstructionBox;
